import { render } from "./TermService.vue?vue&type=template&id=104e3ff2&scoped=true"
import script from "./TermService.vue?vue&type=script&lang=js"
export * from "./TermService.vue?vue&type=script&lang=js"

import "./TermService.vue?vue&type=style&index=0&id=104e3ff2&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-104e3ff2"]])

export default __exports__